import React, { useEffect, useState } from "react";
import { Container, Button, Box } from "@mui/material";
import FormField from "../FormComponent/FormField/FormField";
import styles from './practitioner.module.css'
import { useForm } from 'react-hook-form';
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import isEqual from "lodash/isEqual";

const validationSchema = yup.object({
    clinicDescription: yup.string().max(3000, 'Description cannot exceed 3000 characters')
        .test(
          "not-only-spaces",
          "This field cannot contain only blank spaces",
          (value) => value ? value.trim().length > 0 : true // Ensure non-blank content
        ),
});

const Clinic = ({ sectionData, details }) => {

    const [defaultValues, setDefaultValues] = useState(null);
    const form = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
    });
    const { register, handleSubmit, control, formState: { errors, isDirty }, reset } = form;
    const allFields = sectionData.fields;
    const currentUserId = localStorage.getItem("LPCurrentUserId");

    const clinicDescriptionField = allFields.find(field => field.id === "clinicDescription");
    useEffect(() => {
        if (details) {
            const resData = {
                clinicDescription: details?.data?.description ? details?.data?.description.replace(/<[^>]*>/g, "").trim() : "",
            };
            reset(resData);
            setDefaultValues(resData);
        }
    }, [details, reset]);

    const onSubmit = async (data) => {
        const payload = {
            btn_submit: true,
            listings: [
                {
                    listing_id: details?.ID,
                    title: details?.post_title,
                    address_1: details?.data.address_1,
                    postcode: details?.data.postcode,
                    telephone_1: details?.data?.phone?.raw,
                    specialization: (Object.values(details.data.services || {})),
                    treatments: Object.values(details.data.treatments || {}),
                    description: data.clinicDescription,
                    provideruid: currentUserId,
                    uid: currentUserId
                }
            ]
        };
        try {
            const res = await axiosProxyInstance.post('/signup/2/', payload);
            cogoToast.success("Clinic description Updated Successfully!");
        } catch (err) {
            console.error("Submission failed:", err);
        }
    }
    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box className='margin-top-15'>
                    <Box style={{ flex: "1" }}>
                        <FormField
                            field={clinicDescriptionField}
                            register={register}
                            control={control}
                            errors={errors}
                        />
                        <Box className={styles.submitButtonContainer}>
                            <Button
                                disabled={!isDirty}
                                className={styles.primaryButton}
                                size="large"
                                type="submit"
                            >
                                Save Changes
                            </Button>
                            <Button
                                disabled={!isDirty}
                                className={styles.secondaryButton}
                                size="large"
                                onClick={() => reset(defaultValues)}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </form>
        </Box>
    )
}
export default Clinic